<template>
  <div>
    <div id="page">
      <el-card id="queryForm" :body-style="{padding: '10px 20px 10px 20px'}">
        <el-form :inline="true" size="small" :model="queryForm" ref="queryForm">
          <el-form-item label="用户名：" prop="username">
            <el-input placeholder="模糊查询" v-model="queryForm.username"></el-input>
          </el-form-item>
          <el-form-item label="姓名：" prop="name">
            <el-input placeholder="模糊查询" v-model="queryForm.name"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
            <el-button type="warning" icon="el-icon-refresh" @click="resetFun('queryForm')">重置</el-button>
          </el-form-item>
        </el-form>
      </el-card>
      <el-button-group>
        <el-button type="primary" icon="el-icon-refresh" size="small" @click="search">刷新</el-button>
        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="addFun">新增</el-button>
        <el-button type="primary" icon="el-icon-edit" size="small" @click="editFun">编辑</el-button>
        <el-button type="primary" icon="el-icon-s-custom" size="small" @click="authFun">授权</el-button>
        <el-button type="danger" icon="el-icon-delete" size="small" @click="delFun">删除</el-button>
      </el-button-group>
      <el-table :data="tableData" ref="tableData" @current-change="selectRow" border size="small" stripe height="200" highlight-current-row v-loading="isLoading">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column prop="username" label="用户名" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="name" label="姓名" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="genderName" label="性别" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="birthday" label="生日" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="phone" label="电话" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="email" label="电子邮箱" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="address" label="住址" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="description" label="描述" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="100" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="updateTime" label="更新时间" min-width="100" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column prop="lastLoginTime" label="最后登录时间" min-width="100" align="center" show-overflow-tooltip></el-table-column>
        <el-table-column label="启用" align="center" width="80">
          <template slot-scope="scope">
            <el-switch v-model="scope.row.enable" @change="updateEnable(scope.row)" :active-value="1" :inactive-value="0" active-color="#13ce66" inactive-color="#C0CCDA"></el-switch>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination :current-page="pager.currentPage" :total="pager.total" :page-sizes="pager.pageSizes" @size-change="sizeChange" @current-change="currentChange" background layout="total, sizes, prev, pager, next, jumper"></el-pagination>
    </div>
    <AddOrUpdate ref="addOrUpdate" :refresh="search"/>
    <Auth ref="auth"/>
  </div>
</template>

<script>
import AddOrUpdate from './AddOrUpdate'
import Auth from './Auth'

export default {
  name: 'UserList',
  components: {Auth, AddOrUpdate},
  data () {
    return {
      //加载层显示
      isLoading: false,
      //查询参数
      queryForm: {
        username: '',
        name: ''
      },
      //分页参数
      pager: {
        currentPage: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10, 20, 50, 100]
      },
      //表格数据
      tableData: [],
      //当前选中行
      currentRow: null
    }
  },
  methods: {
    //每页显示条数改变
    sizeChange: function (size){
      this.pager.pageSize = size
      this.search()
    },
    //当前页改变
    currentChange: function(current){
      this.pager.currentPage = current
      this.search()
    },
    //查询数据
    search: function () {
      this.isLoading = true
      //请求数据
      this.$axios({
        method: 'post',
        url: '/sysUser/selectPage',
        data: {
          size: this.pager.pageSize,
          current: this.pager.currentPage,
          orderField: 'id',
          params: [{
            field: 'username',
            type: 'like',
            value: this.queryForm.username
          }, {
            field: 'name',
            type: 'like',
            value: this.queryForm.name
          }, {
            field: 'type',
            type: 'eq',
            value: 1
          }]
        }
      }).then(response => {
        this.isLoading = false
        this.pager.total = response.total
        this.tableData = response.rows
      }).catch(() => {
        this.isLoading = false
      })
    },
    //重置查询条件
    resetFun: function (formName) {
      this.$refs[formName].resetFields()
      this.search()
    },
    //选中行改变
    selectRow: function (currentRow) {
      this.currentRow = currentRow
    },
    //新增
    addFun: function () {
      this.$refs.addOrUpdate.isDialog = true
      this.$refs.addOrUpdate.title = '新增'
    },
    //授权
    authFun: function(){
      if (this.currentRow) {
        //先置空数据表格避免失败后数据表格保留上次的数据
        this.$refs.auth.roleTable = []
        this.$refs.auth.isAuthDialog = true
        this.$refs.auth.userId = this.currentRow.id
      } else {
        this.$message.info('请先选择需要授权的用户！')
      }
    },
    //编辑
    editFun: function () {
      if (this.currentRow) {
        this.$refs.addOrUpdate.title = '编辑'
        this.$refs.addOrUpdate.user = JSON.parse(JSON.stringify(this.currentRow))
        this.$refs.addOrUpdate.isDialog = true
      } else {
        this.$message.info('请先选择需要编辑的数据！')
      }
    },
    //删除
    delFun: function () {
      if (this.currentRow) {
        //确认删除
        this.$confirm('确认删除当前选中数据？', '提示', {
          type: 'warning'
        }).then(() => {
          //删除数据
          this.$axios.get('/sysUser/delete', {
            params: {
              id: this.currentRow.id
            }
          }).then(() => {
            this.search()
            this.$message.success('删除成功~')
          })
        })
      } else {
        this.$message.info('请先选择需要删除的数据！')
      }
    },
    //更新状态
    updateEnable: function(row){
      this.$axios.get('/sysUser/updateEnale', {
        params: {
          id: row.id,
          enable: row.enable
        }
      })
    }
  },
  mounted () {
    //加载完成后动态计算表格的高度
    this.$nextTick(() => {
      $('.el-table').css({
        height: $('#page').height() - $('#queryForm').height() - 95
      })
    })
    //查询表格数据
    this.search()
  }
}
</script>

<style scoped>
#page {
  padding: 10px;
  height: calc(100% - 20px);
}

.el-form-item {
  margin-bottom: 10px;
  margin-top: 10px;
}

.el-form-item .el-input, .el-form-item .el-select {
  width: 170px;
}

.el-button-group {
  margin: 8px 0 5px 0;
}

.el-pagination {
  text-align: right;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/user/UserList.vue